<template>
  <div class="cancel-offer-page">
    <template v-if="canResubscribe">
      <h1>Here's a 1 time offer</h1>
      <p>Get a significant discount: only $19.99/month.</p>
      <div class="close-offer">
        <span class="close-offer-text">*You won't see this offer again.</span>
      </div>
    </template>

    <alert class="alert" v-if="error">
      {{ error }}
    </alert>

    <div>
      <template v-for="(offer, index) in offers">
        <OptionButton
          :key="index"
          @itemSelected="selectOffer(index)"
          :isSelected="offer.selected"
          :isLoading="offer.loading"
          :disabled="isLoading"
          >{{ offer.text }}</OptionButton
        >
      </template>
    </div>
  </div>
</template>

<script>
import OptionButton from "@/components/OptionButton";
import Alert from "@/components/Alert";

export default {
  name: "CancelOfferPage",
  components: {
    OptionButton,
    Alert,
  },
  computed: {
    previousAmount() {
      return this.$user.getSubscriptionPricing();
    },
    canResubscribe() {
      const amount = this.$user.getSubscriptionPricing();
      return amount !== 1999 && amount !== 999;
    },
  },
  data() {
    return {
      isLoading: false,
      error: null,
      offers: [
        {
          text: "Yes, please switch my plan to $19.99/month",
          selected: false,
          loading: false,
        },
        { text: "Lose this deal forever", selected: false, loading: false },
      ],
    };
  },
  methods: {
    goToSubscription() {
      this.$router.push({ name: "subscription" });
    },
    selectOffer(val) {
      if (val === 0) {
        this.offers[0].selected = true;
        this.offers[0].loading = true;
        this.isLoading = true;
        this.error = null;
        let previousAmount = this.$user.getSubscriptionPricing();
        let previousInterval = this.$user.getSubscriptionInterval();
        let data = {
          previous_plan_price: `${previousAmount}/${previousInterval}`,
          new_plan_price: "19.99/1 Month",
        };
        this.$user
          .subscriptionRescue()
          .then(this.$user.getProfile.bind(this.$user))
          .then(this.subscriptionRescue)
          .then(this.$tracker.trackPlanChanged(data))
          .catch(this.handleSubscriptionRescueError);
      } else if (val === 1) {
        this.offers[1].selected = true;
        this.offers[1].loading = true;
        this.$router.push({ name: "cancelConfirm" });
      }
    },
    subscriptionRescue() {
      this.$user.getProfile();
      this.$router.push({ name: "rescueConfirmation" });
    },
    handleSubscriptionRescueError() {
      this.error =
        "Something went wrong updating your subscription. Please try again.";
      this.isLoading = false;
      this.offers[0].loading = false;
      this.offers[0].selected = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/mixins";
@import "@/style/variables.scss";

.cancel-offer-page {
  p {
    color: $lighter-black;
    line-height: 30px;
    font-size: 16px;
  }
}

.close-offer-text {
  font-family: Noto Sans;
  font-style: italic;
  font-weight: normal;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  color: #1d1d1d;
}

.close-offer {
  margin-bottom: 30px;
}
</style>
